<template>
  <div v-if="visible" class="modal-overlay">
    <!-- buttons on map weather -->
    <div class="weather-setting-buttons">
      <slot name="controls" />
    </div>

    <!-- map weather -->
    <iframe
      v-if="iframeSrc"
      ref="iframe"
      :src="iframeSrc"
      frameborder="0"
      class="full-frame"
      @load="onLoad"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "WeatherMTK",
  props: {
    lat: { type: Number, default: null },
    lng: { type: Number, default: null },
    zoom: { type: Number, default: 8 },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      iframeSrc: null,
      iframeReady: false,
      lastKnownLocation: null,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.setIframeSrc();
        this.addMessageListener();
      } else {
        this.removeMessageListener();
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.setIframeSrc();
      this.addMessageListener();
    }
  },
  beforeDestroy() {
    this.removeMessageListener();
  },
  methods: {
    setIframeSrc() {
      const lat = this.lat ?? 45.943;
      const lng = this.lng ?? 24.966;
      const zoom = this.zoom ?? 8;
      this.iframeSrc = `/weather.html?lat=${lat}&lng=${lng}&zoom=${zoom}`;
      console.log(" iframeSrc set:", this.iframeSrc);
    },
    addMessageListener() {
      window.removeEventListener("message", this.receiveMessage);
      window.addEventListener("message", this.receiveMessage);
    },
    removeMessageListener() {
      window.removeEventListener("message", this.receiveMessage);
    },
    onLoad() {
      this.iframeReady = true;
      this.sendLocation(this.lat, this.lng, this.zoom);
    },
    sendLocation(lat, lon, zoom) {
      if (!this.iframeReady) return;
      const iframe = this.$refs.iframe;
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: "set-location",
            payload: { lat, lon, zoom },
          },
          "*"
        );
      }
    },
    receiveMessage(e) {
      if (e.data?.type === "weather-location-changed") {
        this.lastKnownLocation = e.data.payload;
        this.$emit("locationChanged", e.data.payload);
      }
    },
    close() {
      // Close the map and send the last known location
      if (this.lastKnownLocation) {
        this.$emit("locationChanged", this.lastKnownLocation);
      }
      this.$emit("close");
    },
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.full-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 1;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 20px;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  z-index: 10;
}

</style>

<style>
/* only the externally inherited slot */
#setting-buttons {
  position: absolute;
  bottom: 0;
  right: 15px !important;
  display: flex;
  flex-direction: row;
  gap: 8px;
  z-index: 10;
}
</style>